const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "SkyRidge",

  webfeedDebuggerWebsiteUrl: "https://skyridgeliving.com.au/land-for-sale",
  webfeedConfig: {
    mode: "masterplan",
    type: "land"
  }
  //   snitchDevices: ["skyridge-1"]
};
